module.exports = __webpack_public_path__ + "static/img/zhuangjintexin.c8e1108.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/honors/zhuangjintexin.png
// module id = +6h6
// module chunks = 7